import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import CustomPagination from "../../common/custompagination";
import {
  TrimText,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import {
  TempleServiceList,
  TempleServiceDelete,
  TempleServiceStatusChange,
} from "../../services/temple-service.services";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

const ServiceListTemple = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [statusUpdate, setStatusUpdate] = useState(false);
  const [globalSearch, setGlobalSearch] = useState("");
  const [list, setList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [datalength, setDataLength] = useState("");

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Temple"), url: "/admin/temples/list/1" },
    { title: t("Temple Services"), url: "" },
  ];

  // Fetch Temple Services
  const fetchData = () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("page", page);
    formData.append("per_page", itemPerPage);
    formData.append("global_search", globalSearch);

    TempleServiceList(formData)
      .then((res) => {
        setDataLength(res?.data?.total_records);
        setList(res?.data?.list || []);
        setTotalRecords(res?.data?.total_records || 0);
        setPage(res?.data?.page || 1);
        setLoader(false);
        console.log(res?.data?.list);
      })
      .catch(() => setLoader(false));
  };

  useEffect(() => {
    fetchData();
  }, [page, globalSearch, statusUpdate]);

  const resetFilter = () => {
    setGlobalSearch("");
    setPage(1);
  };

  const deleteService = (id) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        TempleServiceDelete(id).then((res) => {
          setStatusUpdate(!statusUpdate);
          Swal.fire({
            icon: res.success ? "success" : "error",
            text: res.success ? res.message : handleServerValidations(res),
            ...SWAL_SETTINGS,
          });
        });
      }
    });
  };

  const changeStatus = (templeId) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("You are about to change the status of this temple"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("Cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("Confirm"),
    }).then((result) => {
      if (result.isConfirmed) {
        TempleServiceStatusChange({ o_id: templeId })
          .then((response) => {
            setStatusUpdate((prev) => !prev);
            Swal.fire({
              icon: response.success ? "success" : "error",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              text:
                error?.response?.data?.message ||
                error?.message ||
                "Server error, please try again",
              ...SWAL_SETTINGS,
            });
          });
      }
    });
  };

  const groupedServices = list.reduce((acc, service) => {
    const templeName = service.temple?.templeName || "Unknown Temple";
    if (!acc[templeName]) acc[templeName] = [];
    acc[templeName].push(service);
    return acc;
  }, {});

  return (
    <>
      <Breadcrums data={breadcrumbs} />

      <div className="card custom-card">
        <div className="card-body">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h6 className="main-content-label">{t("Temple Service")}</h6>
            <div className="d-flex align-items-center">
              <div className="form-group mb-0 me-3">
                <div className="form-group mb-0 rangepicker_container filter_design">
                  <i className="fa fa-search calender_icon"></i>
                  <input
                    type="search"
                    className="form-control"
                    value={globalSearch}
                    placeholder={t("input_placeholder_search")}
                    onChange={(e) => setGlobalSearch(e.target.value)}
                  />
                </div>
              </div>
              <button
                type="reset"
                className="btn btn-warning me-2"
                onClick={resetFilter}
              >
                {t("btn_reset_filter")}
              </button>
              <button
                className="btn ripple btn-main-primary signbtn mr-2"
                onClick={() => navigate("/admin/temple-service/add")}
              >
                {t("btn_add_new")}
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-bordered w-100">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{t("Service Name")}</th>
                  <th>{t("Type")}</th>
                  <th>{t("Duration")}</th>
                  <th>{t("Description")}</th>
                  <th>{t("Price")}</th>
                  <th>{t("Status")}</th>
                  <th>{t("Action")}</th>
                </tr>
              </thead>
              <tbody>
                {loader ? (
                  <tr>
                    <td colSpan={9}>
                      <Loader />
                    </td>
                  </tr>
                ) : list.length ? (
                  list.map((templeItem, idx) => (
                    <React.Fragment key={templeItem._id}>
                      <tr>
                        <td colSpan={9} className="fw-bold bg-light">
                          {templeItem.templeName}
                        </td>
                      </tr>

                      {templeItem.services.map((service, i) => (
                        <tr key={service._id}>
                          <td>{(page - 1) * itemPerPage + i + 1}</td>
                          <td>{TrimText(service.name, 20)}</td>
                          <td>{service.serviceType}</td>
                          <td>{service.duration}</td>
                          <td>{TrimText(service.description || "", 30)}</td>
                          <td>₹ {service.price}</td>
                          <td>
                            <button
                              type="button"
                              className={`btn ripple ${service.status ? "btn-main-primary signbtn" : "btn-secondary"}`}
                              onClick={() => changeStatus(service._id)}
                            >
                              {service.status ? t("Active") : t("Inactive")}
                            </button>
                          </td>
                          <td>
                            <button
                              className="btn ripple btn-main-primary signbtn me-2"
                              onClick={() =>
                                navigate(
                                  `/admin/temple-service/view/${service._id}`,
                                )
                              }
                            >
                              {t("View")}
                            </button>
                            <button
                              className="btn btn-success me-2"
                              onClick={() =>
                                navigate(
                                  `/admin/temple-service/edit/${service._id}`,
                                )
                              }
                            >
                              {t("Edit")}
                            </button>
                            <button
                              className="btn btn-danger"
                              onClick={() => deleteService(service._id)}
                            >
                              {t("Delete")}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={9} className="text-center">
                      {t("msg_no_records")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div id="example1_info" role="status" aria-live="polite">
            <b>
              {t("msg_total_records")} : {datalength ? datalength : "0"}
            </b>
          </div>
          {datalength && datalength > 0 && (
            <CustomPagination
              datalength={datalength}
              itemperpage={itemPerPage}
              currentPage={page}
              setPage={setPage}
              pageRoute={[
                {
                  name: "PageTable",
                  path: "/admin/temple-service/list",
                },
              ]}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ServiceListTemple;
